import { useThemePalette } from '@/hooks/useThemePalette';
import LunarMoonBackground from './LunarMoonBackground';
import CinemaModeBackground from './CinemaModeBackground';
import { useCinemaMode } from '@/contexts/CinemaModeContext';

// This component renders special backgrounds for themes that need them
const ThemeBackground = () => {
  const { palette } = useThemePalette();
  const { cinemaMode } = useCinemaMode();

  const isLunarMoon = palette === 'lunar-moon';

  // Cinema Mode should work across all themes
  if (cinemaMode) {
    return <CinemaModeBackground />;
  }

  // Lunar Moon theme default (no cinema mode) - show default space background
  if (isLunarMoon) {
    return <LunarMoonBackground />;
  }

  // Other themes use the standard background from CSS variables
  return null;
};

export default ThemeBackground;
